import { FormattedMessage } from 'react-intl';

const { IconLibrary } = require('@product-framework/index');

function getSPLevelStackableButtons({ navigate }) {
  const stackablePageButtons = [
    {
      label: (
        <FormattedMessage
          id="CREATE_SERVICE_PROVIDER"
          defaultMessage="Create Service Provider"
        />
      ),
      id: 'CREATE_SERVICE_PROVIDER',
      Icon: IconLibrary.ServiceProvider,
      variant: 'outlined',
      permissionName: 'CAN_CREATE_SP',
      onClick: () => {
        navigate('/serviceproviders/create');
      },
    },
    {
      label: (
        <FormattedMessage
          id="LIST_SERVICE_PROVIDERS"
          defaultMessage="List Service Providers"
        />
      ),
      id: 'LIST_SERVICE_PROVIDERS',
      permissionName: 'CAN_LIST_SP',
      Icon: IconLibrary.ServiceProviders,
      variant: 'outlined',
      onClick: () => navigate('/serviceproviders'),
    },
  ];
  return stackablePageButtons;
}

export default getSPLevelStackableButtons;
